import React from 'react';

type BadgeVariant = 'rn' | 'cna' | 'lpn' | 'np' | 'md' | 'active' | 'pending' | 'expired' | 'draft' | 'approved' | 'rejected' | 'open' | 'assigned' | 'completed' | 'default';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
  dot?: boolean;
}

const variantClasses: Record<BadgeVariant, string> = {
  rn: 'badge-rn',
  cna: 'badge-cna',
  lpn: 'badge-lpn',
  np: 'badge-np',
  md: 'badge-md',
  active: 'status-active',
  pending: 'status-pending',
  expired: 'status-expired',
  draft: 'status-draft',
  approved: 'status-approved',
  rejected: 'status-rejected',
  open: 'status-open',
  assigned: 'status-assigned',
  completed: 'status-completed',
  default: 'bg-muted text-muted-foreground',
};

export default function Badge({ variant = 'default', children, className = '', dot = false }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-600 ${variantClasses[variant]} ${className}`}
    >
      {dot && <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70 flex-shrink-0" />}
      {children}
    </span>
  );
}